import Icon from "@mui/material/Icon";
// import MDBadge from "../../../../components/MDBadge";
import {useEffect, useMemo, useState} from "react";
import CustomService from "../../../services/custome.service";
import GHIconButton from "../../../components/GHIconButton";

export function useCountriesTable(clickItem) {

  const [rows, setRows] = useState([]);

  const columns = [
    { Header: "Name", accessor: "name", width: "20%" },
    { Header: "ShortName", accessor: "short", width: "20%" },
    { Header: "Code", accessor: "code", width: "20%" },
    { Header: "Actions", accessor: "action", width: "7%" },
  ];

  useEffect(() => {
    CustomService.getCountries()
      .then((res) => {
        setRows(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []); 

  return {
    columns,
    rows: rows
      ? rows.map((element) => ({
          id: element.id,
          short: element.short_name,
          name: element.name,
          code: element.code,
          action: (
            <GHIconButton
              onClick={clickItem}
              id={element.id}
              title="Delete"
              icon="delete"
              size="small"
              color="error"
            />
          ),
        }))
      : [],
  };
}
